import React, { useState } from 'react'

import PropTypes from 'prop-types'

import { useActivities } from '../../context/Activities'
import { Input, SelectHarvest } from './theme'

const HarvestSelector = props => {
  const {
    label,
    options
  } = props
  const { currentHarvest, changeHarvest } = useActivities()
  const [selectedOption, setSelectedOption] = useState(currentHarvest)

  const onChangeHandler = (_, newValue) => {
    setSelectedOption(newValue)
    changeHarvest(newValue)
  }

  return (
    <SelectHarvest
      name="harvest-selector"
      options={ options }
      value={ selectedOption }
      onChange={ onChangeHandler }
      getOptionLabel={ option => option.label }
      getOptionSelected={ (option, selected) => option.value === selected.value }
      renderInput={
        params => (
          <Input
            { ...params }
            label={ label }
            margin="normal"
          />
        )
      }
      disableClearable
    />
  )
}

HarvestSelector.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
}

export default HarvestSelector
